import { ResizeHandle } from "./ResizeHandle";
import { clampLabelWidth, clampRowHeight } from "@/lib/scheduleRowHeights";
import type { ScheduleRowHeights } from "@/hooks/useScheduleRowHeights";
import type { ScheduleLabelWidth } from "@/hooks/useScheduleLabelWidth";

interface ScheduleRowResizeHandlesProps {
  rowKey: string;
  rowHeight: number;
  rowHeights: ScheduleRowHeights;
  labelWidth: ScheduleLabelWidth;
}

/**
 * The pair of resize handles every schedule row-label cell gets: row height
 * on the bottom edge, label-column width on the right edge. (The width is a
 * single shared value; the handle is repeated per row so the column edge is
 * grabbable anywhere.)
 */
export function ScheduleRowResizeHandles({
  rowKey,
  rowHeight,
  rowHeights,
  labelWidth,
}: ScheduleRowResizeHandlesProps) {
  return (
    <>
      <ResizeHandle
        axis="y"
        value={rowHeight}
        clamp={clampRowHeight}
        onChange={(h) => rowHeights.setRowHeight(rowKey, h)}
        onReset={() => rowHeights.resetRowHeight(rowKey)}
        ariaLabel="Adjust row height"
        title="Drag to adjust row height (double-click to reset)"
      />
      <ResizeHandle
        axis="x"
        value={labelWidth.labelWidth}
        clamp={clampLabelWidth}
        onChange={labelWidth.setLabelWidth}
        onReset={labelWidth.resetLabelWidth}
        ariaLabel="Adjust label column width"
        title="Drag to adjust label width (double-click to reset)"
      />
    </>
  );
}
